import React, { Component } from 'react';
import 'ant-design-pro/dist/ant-design-pro.css';
import Result from 'ant-design-pro/lib/Result';
import { Steps, Button, message, Input, Icon, Row, Col, Modal, Form, Checkbox, AutoComplete, Select, Alert,Popover,Progress} from 'antd';
import $ from "jquery"
import EventSet from "./../../../assets/PubJs/hcPub"
import "./LoginForget.css"
import createHistory from 'history/createHashHistory'
import { Hcurl } from "./../../../constants/index"//获取公共路径
import logo from "./../../../assets/images/loginLogo1.png"

const history = createHistory();
const Step = Steps.Step;
const confirm = Modal.confirm;

const FormItem = Form.Item;
const Option = Select.Option;
const AutoCompleteOption = AutoComplete.Option;
var loginName = '';
let base = new EventSet.Base64();

const steps = [{
    title: '确认账号',
    content: '填写需要找回账号的用户名或手机号码。',
}, {
    title: '安全验证',
    content: '为了您的账号安全，请完成身份验证。',
}, {
    title: '重置密码',
    content: '输入您的新密码，完成密码重置操作。',
}];

var userPhone = ""; //手机号码

var userPhone = ""; //手机号码
var U_ID = '';
var loginName = '';

//确认账号
let _QueryAccount = null;
class QueryAccount extends React.Component {
    state = {
        alertShow: ""
    }
    componentWillMount() {
    }

    componentDidMount() {
        _QueryAccount = this;

        // //执行滑动验证
        // EventSet.slide(window)
        // //滑动验证
        // window.jigsaw.init(document.getElementById('captcha'), function () { })
    }

    //账号密码错误关闭
    onClose = () => {
        _QueryAccount.setState({
            alertShow: null
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form onSubmit={this.handleSubmit} className="forget-form">
                <p style={{marginBottom:'0'}}>Step1：请输入您的手机号</p>
                {this.state.alertShow}
                <FormItem>
                    {getFieldDecorator('userName', {
                        rules: [{ required: true, message: '请输入手机号' },{ pattern: /^1[0-9]{10}$/, message: '手机号格式错误' }],
                    })(
                        <Input prefix={<Icon type="mobile" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="手机号" size="large" style={{ marginTop: "20px" }}/>
                        )}
                </FormItem>
                {/* <div id="captcha" style={{ position: "relative" }}></div> */}
            </Form>
        );
    }
}
const WrappedNormalLoginForm = Form.create()(QueryAccount);

//安全验证
let _SafeTest = null;
let time = null;
class SafeTest extends React.Component {
    state = {
        autoCompleteResult: [],
        captcha: "获取验证码",
        captDisable: "",
        linkPhone:'',
        visible:false,
        level:'弱',
        proColor:'#f5222d',
        source:33,
        sourceText:'8-16位，须同时包含字母、数字、符号，区分大小写，请不要使用容易被猜到的密码。'
    };
    componentDidMount() {
        _SafeTest = this;
    }

    //组件卸载时
    componentWillUnmount = () => {
        //定时器
        window.clearInterval(time);
    }

    //获取验证码
    getCaptcha = () => {

        $.ajax({
            url: Hcurl + "/user/SendMsgByPhone?loginName=" + loginName,
            type: "get",
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
               
                if (res.indexOf("true") >= 0) {
                    message.success("验证码发送成功");

                    // EventSet.setCookie("captcha", base.encode(num), "m5");
                    _SafeTest.setState({
                        captcha: "60s",
                        captDisable: "true"
                    }, () => {
                        var timer = 60;
                        time = setInterval(function () {
                            timer--;
                            _SafeTest.setState({
                                captcha: timer + "s"
                            }, () => {
                                if (timer == 0) {
                                    window.clearInterval(time);
                                    _SafeTest.setState({
                                        captcha: "获取验证码",
                                        captDisable: ""
                                    })
                                }
                            })
                        }, 1000)
                    })
                } else {
                    message.error("验证码发送失败");
                }
            }
        })
    }

    
    compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback('两次输入的密码不匹配！');
        } else {
            callback();
        }
    }
    myIsNaN(value) {
        return typeof value === 'number' && !isNaN(value);
    };
   
      FirstPassword(rule, value, callback) {
        console.log('894',value)
        if(!value)
        {
          callback()
          _SafeTest.setState({
            visible:false,
        })
        }
        else if(/^.*[\u4E00-\u9FA5].*$/.test(value))
        {
          callback('密码中不可包含中文')
        }
        else
        {
            _SafeTest.setState({
                visible:false,
            })
          if(value.indexOf(' ')>-1){
            callback('密码中不可包含空格');
          }
        
          else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)(?![\W]+$)(?![0-9a-zA-Z]+$)(?![0-9a-z\W]+$)(?![0-9\W]+$)(?![a-zA-Z\W]+$)[0-9A-Za-z\W]{8,16}$/.test(value)) {
            callback('8-16位，须同时包含字母、数字、符号，区分大小写。');
          } 
          else {
            if(EventSet.returnScore(value) < 60)
            {
                console.log('1063')
              callback('密码太简单了，请重新设置。');
            }
            else if(sessionStorage.getItem('codeData') && sessionStorage.getItem('codeData').split('臡').indexOf(value)>-1)
            {
              callback('密码太简单了，请重新设置。');
              _SafeTest.setState({
                proColor:'#f5222d',
                level:'弱',
                source:33
                })
            }
            // else if(value == 'Welcome.1')
            // {
            //     console.log('1072')
            //   callback('不可以设置为初始密码');
            // }
            else
            {
                _SafeTest.setState({
                    visible:true,
                })
                if(EventSet.returnScore(value)<60){
                    _SafeTest.setState({
                        proColor:'#f5222d',
                        level:'弱',
                        source:33
                    })
                }else if (EventSet.returnScore(value)>59&&EventSet.returnScore(value)<80){
                    _SafeTest.setState({
                        proColor:'orange',
                        level:'中',
                        source:66
                    })
                }else{
                    _SafeTest.setState({
                        proColor:'#52c41a',
                        level:'强',
                        source:99
                    })
                }
              callback();
            }
          }
        }
      };
      blur=()=>{
        _SafeTest.setState({
            visible:false,
           
        })
      }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { autoCompleteResult } = this.state;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };

        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 24,
                    offset: 0,
                },
            },
        };
        return (
            <Form>
                <p style={{marginBottom:'24px'}}>Step2：输入您的新密码，完成密码重置操作。</p>
                <Popover
                            placement="rightTop"
                            content={<div style={{width:'290px',padding:'10px 10px'}}>
                                <p style={{color:this.state.proColor,marginBottom:'0'}}>强度：{this.state.level}</p>
                                <Progress strokeColor={this.state.proColor} percent={this.state.source} showInfo={false} />
                                <p style={{marginBottom:'0'}}>{this.state.sourceText}</p>
                            </div>}
                            title="密码强度"
                            trigger="click"
                            visible={this.state.visible}
                        >
                <div></div>
                </Popover>
                 <FormItem
                    {...formItemLayout}
                >
                    {getFieldDecorator('password', {
                        rules: [{
                            required: true, message: '请输入密码！',
                        },{ validator: this.FirstPassword}],
                    })(
                      <Input onBlur={this.blur}  type="password" placeholder="8-16位，须同时包含字母、数字、符号" size="large" maxLength="16" />
                        )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                >
                    {getFieldDecorator('confirm', {
                        rules: [{
                            required: true, message: '请确认密码！',
                        }, {
                            validator: this.compareToFirstPassword,
                        }],
                    })(
                        <Input  type="password" onBlur={this.handleConfirmBlur} placeholder="请确认密码" size="large" maxLength="20"/>
                        )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                >
                    {getFieldDecorator('phone', {
                        rules: [{ required: false, message: 'Please input your phone number!' }],
                    })(
                        <Input style={{ width: '100%' }} disabled size="large" />
                        )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                >
                    <Row gutter={8}>
                        <Col span={16}>
                            {getFieldDecorator('captcha', {
                                rules: [
                                    {
                                        required: true, message: '请输入验证码!'
                                    }],
                            })(
                                <Input maxLength="6" size="large" placeholder="请输入验证码" />
                            )}
                        </Col>
                        <Col span={8}>
                            <Button size="large" onClick={this.getCaptcha} style={{ width: "115px" }} disabled={this.state.captDisable}>{this.state.captcha}</Button>
                        </Col>
                    </Row>
                </FormItem>
            </Form>
        );
    }
}

const SafeProve = Form.create()(SafeTest);

//重置密码  
let _ResetPassword = null;
class ResetPassword extends React.Component {
    state = {
        confirmDirty: false,
        autoCompleteResult: [],
    };
    componentDidMount() {
        _ResetPassword = this;
    }
    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    }
    compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback('两次输入的密码不匹配！');
        } else {
            callback();
        }
    }
    validateToNextPassword = (rule, value, callback) => {
      let reg = /^\S*$/;
      let text='长度为8-16个字符，必须包含字母、数字、符号中至少2种，不包括空格！';
      if (reg.test(value) == false) {
        callback(text);
      } else {
        const form = this.props.form;
        if (value != undefined) {
          if(value.length!=0){
            let reg2=/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,16}$/;
            if (!reg2.test(value)) {
              callback(text);
            } else {
              callback();
            }
          }
        }
        if (value && this.state.confirmDirty) {
          form.validateFields(['confirm'], { force: true });
        }
        callback();
      }
    }


    render() {
        const { getFieldDecorator } = this.props.form;
        const { autoCompleteResult } = this.state;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };
        return (
            <Form>
                <FormItem
                    {...formItemLayout}
                >
                    {getFieldDecorator('password', {
                        rules: [{
                            required: true, message: '请输入密码！',
                        },{ validator: this.validateToNextPassword}],
                    })(
                      <Input style={{fontSize:'14px'}} type="password" placeholder="8-16位，须同时包含字母、数字、符号" size="large" maxLength="16" />
                        )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                >
                    {getFieldDecorator('confirm', {
                        rules: [{
                            required: true, message: '请确认密码！',
                        }, {
                            validator: this.compareToFirstPassword,
                        }],
                    })(
                        <Input style={{fontSize:'14px'}} type="password" onBlur={this.handleConfirmBlur} placeholder="请确认密码" size="large" maxLength="16"/>
                        )}
                </FormItem>
            </Form>
        );
    }
}
const Reset = Form.create()(ResetPassword);

let _StepApp = null;

class StepApp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            captcha: "获取验证码",
            captDisable: "",
            confirmUser: "block",
            testUser: "none",
            resetUser: "none",
            result: "none",
            query: "none",
            btnWidth: "200px",
            return: "block",
            resetName: "",
            loading: false,
            queryLoading:false,
            alertShow:'',
        };
    }
    componentDidMount() {
        _StepApp = this;
    }

    //点击下一步
    next() {
        const { form } = _QueryAccount.props;
        const { ...safeform } = _SafeTest.props;

        //第一步
        if (this.state.current == 0) {
            form.validateFields((err, fieldsValue) => {
                if (err) {
                    return;
                } else {
                    _StepApp.setState({
                        loading: true
                    })
                    //滑动拼图验证
                    // if (localStorage.getItem("slideTest") != undefined && localStorage.getItem("slideTest") == "true" && localStorage.getItem("slideTest") != null && localStorage.getItem("slideTest") != "") {
                        $.ajax({
                            url: Hcurl + "/user/Vaild",
                            type: "post",
                            headers: {
                                "token": EventSet.getUserInfo()['token']
                            },
                            async: false,
                            data: {
                                userName: fieldsValue.userName
                            },
                            success: function (res) {
                                _StepApp.setState({
                                    loading: false
                                })
                                //手机号验证
                                if (res.indexOf("false") >= 0) {
                                    setTimeout(function () {
                                        _QueryAccount.setState({
                                          alertShow: <Alert style={{marginTop:'15px'}} message={res.split('|')[1]} type="error" showIcon />
                                        })
                                      }, 50)
                                    // Modal.warning({
                                    //     title: '手机号码不存在，请重新输入！',
                                    //     content: '',
                                    //     okText: "知道了",
                                    //     onOk() {
                                    //         _QueryAccount.props.form.setFieldsValue({
                                    //             userName: ""
                                    //         })
                                    //     }
                                    // });
                                } else {
                                    _QueryAccount.setState({
                                        alertShow:""
                                      })
                                    const current = _StepApp.state.current + 1;
                                    _StepApp.setState({ current }, () => {
                                        _StepApp.setState({
                                            confirmUser: "none",
                                            testUser: "block",
                                            resetUser: "block",
                                            query: "block",
                                            return: "none"
                                        })
                                    });
                                    const userInfo = JSON.parse(res);
                                    userPhone = fieldsValue.userName;
                                    // U_ID = userInfo.U_ID;
                                    loginName = fieldsValue.userName;
                                    _SafeTest.setState({
                                        linkPhone:fieldsValue.userName
                                    })
                                    _SafeTest.props.form.setFieldsValue({
                                        user: userInfo.userName,
                                        phone: userInfo.linkPhone
                                    })
                                }
                            }
                        })
              
                }
            })
        } else {
            //第二步
            safeform.form.validateFields((err, fieldsValue) => {
                if (err) {
                    return;
                } else {
                    const current = _StepApp.state.current + 1;
                    _StepApp.setState({ current }, () => {
                        _StepApp.setState({
                            confirmUser: "none",
                            testUser: "none",
                            resetUser: "block",
                            query: "block"
                        })
                    });
                }
            })
        }
    }

    //重置成功前往登录
    login = () => {
        history.push({ pathname: '/Login/LoginMain/LoginEntry', })
    }

    //重置密码第三步点击确定
    submit = () => {
        const { form } = _SafeTest.props;
        const code = _SafeTest.props.form.getFieldValue("captcha");
        form.validateFields((err, fieldsValue) => {
            if (err) {
                _SafeTest.setState({
                    visible:false
                })
                return;
            } else {
                _SafeTest.setState({
                    visible:false
                })
                _StepApp.setState({
                    queryLoading:true
                })

                setTimeout(function () {
                    $.ajax({
                        url: Hcurl + "/user/UpdateRestPassword",
                        type: "post",
                        headers: {
                            "token": EventSet.getUserInfo()['token']
                        },
                        data: {
                            U_LoginName: _SafeTest.state.linkPhone,
                            ValidCode:code,
                            NewPassword1: _SafeTest.props.form.getFieldValue("password"),
                            NewPassword2: _SafeTest.props.form.getFieldValue("password")
                        },
                        success: function (res) {
                            _StepApp.setState({
                                queryLoading: false
                            })

                            if (res.indexOf("true") >= 0) {
                                _StepApp.setState({
                                    confirmUser: "none",
                                    testUser: "none",
                                    resetUser: "none",
                                    result: "block",
                                    query: "none",
                                    resetName: _QueryAccount.props.form.getFieldValue("userName"),
                                    
                                })
                                _SafeTest.setState({
                                    visible:false
                                })
                            } else {
                                message.warn(res.split("|")[1]);
                            }
                        }
                    })
                },100)
            }
        })
        
    }

    //返回登录界面
    returnLogin = () => {
        history.push({ pathname: '/Login/LoginMain/LoginEntry', })
    }
    render() {
        const { current } = this.state;
        return (
            <div>
                  <p style={{ textAlign: "center", fontSize: "22px", color: "#333",marginBottom:0 }}>
                江苏省“智慧315”综合服务平台
                </p>
                <p style={{ textAlign: "center", fontSize: "18px", color: "#333",marginBottom:0 }}>
                商家成员登录
                </p>
                
                <div className="confirmUserName" style={{ display: this.state.confirmUser }}>
                    {this.state.alertShow}
                    <WrappedNormalLoginForm />
                </div>
                <div className="testUserName" style={{ display: this.state.testUser }}>
                    <SafeProve/>
                </div>
                <div className="steps-action" style={{ display: (this.state.query=='block'||this.state.result=='block') ?'none':'block'}}>
                        <div>
                            <Button type="primary" onClick={() => this.next()} style={{ width: this.state.btnWidth }} size="large" loading={this.state.loading}>下一步</Button>
                            <a style={{ float: "right", lineHeight: "40px",}} onClick={this.returnLogin}>返回登录页面</a>
                        </div>
                </div>
                <div className="steps-action" style={{ display: this.state.query }}>
                    <Button type="primary" style={{ width: "200px" }} onClick={this.submit} size="large" loading={this.state.queryLoading}>提交</Button>
                    <a style={{ float: "right", lineHeight: "40px",}} onClick={this.returnLogin}>返回登录页面</a>
                </div>
                <Result
                    type="success"
                    title={<div>密码重置成功</div>}
                    description={<div style={{ color: '#ccc' }}>恭喜，您的密码已重置成功！</div>}
                    actions={<Button type="primary" style={{ width: "350px" }} size="large" onClick={this.login}>前往登录</Button>}
                    style={{ display: this.state.result, marginTop:"20px" }}
                />
            </div>
        );
    }
}

class App extends Component {
    render() {
        return (
            <div className="LoginWrap">
                <div className="LoginTitle">
                    <div className="forgetPassword" style={{ marginTop: 100 }}>
                        <StepApp />
                    </div>
                </div>
            </div>
        );
    }
}

export default App


// WEBPACK FOOTER //
// ./src/components/Login/LoginForget/LoginForget.js